module.exports = __webpack_public_path__ + "img/pdf-uploaded.254312b6.svg";